import { fetchGet } from 'Services/fetchService.js';
import { slimPath } from 'Config/path.js';

export default async () => {
    const responce = fetchGet(`${slimPath}/options/getoptions?user=forMe&target=miniForm`);

    return responce;
};
